import { FunctionComponent, useCallback, useEffect } from 'react'
import {
  IWidgetConfiguration,
  usePlatformConfig,
  useWidgetContext,
} from '@dxp-module/common'
import { DXPWidget } from '../../../main'

// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const MiniMyAccountInitializer: FunctionComponent = () => {
  const {
    platformConfig: { myAccount },
  } = usePlatformConfig()
  const { configuration } = useWidgetContext()
  const miniMyAccountContainer = 'dxp-myaccount-mini-container'
  const selector = myAccount?.miniMyAccountConfig?.dom as string

  const initializeWidget = () => {
    if (!document.getElementById(miniMyAccountContainer)) return

    const widgetConfig = {
      cookieDomain: configuration.cookieDomain,
      containerId: miniMyAccountContainer,
      myAccountUrl: configuration.basePath,
      dimensions: configuration.dimensions,
    } as IWidgetConfiguration

    DXPWidget.createMiniWidget(widgetConfig)
  }

  const selectedDOM: () => Element | null = useCallback(() => {
    const queryDOM = document.querySelector(selector)

    if (selector && queryDOM !== null) {
      return queryDOM
    }
    return document.querySelector('.header_inset')
  }, [selector])

  useEffect(() => {
    if (!document.getElementById(miniMyAccountContainer)) {
      const miniMyAccount = document.createElement('div')
      miniMyAccount.id = miniMyAccountContainer
      if (
        myAccount?.miniMyAccountConfig?.style &&
        !!document.querySelector(selector)
      ) {
        miniMyAccount.setAttribute('style', myAccount.miniMyAccountConfig.style)
      }
      selectedDOM()?.appendChild(miniMyAccount)
    }
    initializeWidget()
  }, [])

  return null
}

export default MiniMyAccountInitializer
